// https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/foundations/borders.ts
export const borders = {
    none: 0,
    '1px': '1px solid',
    '2px': '2px solid',
    '4px': '4px solid',
    '8px': '8px solid'
}
